<template>
    <li class="node-tree">
        <span><a target="_blank" :href="'services#openId='+ node.id"> {{ node.name }}</a></span>
        <ul v-if="node.children && node.children.length">
            <node v-for="child in node.children" :key="child.id" :node="child"></node>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'node',
    props: {
        node: Object
    }
};
</script>
